import React from "react";
import { CONFIG } from '../../../config.js';

const UserManagement = () => {
    const urlUserMgmt = CONFIG.user_mgmt_url + "/app/users/";
    return (
       <div style={{width: '100%'}}>
            <iframe style={{ display: 'block', width: '100%', minHeight: 800, border: 'none' }}
                src={urlUserMgmt.toString()} title="User Management"></iframe>
        </div>
    )
};

export default UserManagement;
